<template>
    <div class="Statistics">
        <div class="count">
            <div class="left label">
                <p>已开通乘车码</p>
                <p>
                    <span :style="{ color: '#FF8921' }">{{
                        sum2 ? sum2 : 0
                    }}</span>
                    人
                </p>
            </div>
            <div class="right label">
                <p>未开通乘车码</p>
                <p>
                    <span :style="{ color: '#FF8921' }">{{
                        sum ? sum : 0
                    }}</span>
                    人
                </p>
            </div>
        </div>
        <div class="list">
            <div class="null" v-show="isData">
                <img src="../assets/imgs/null.png" />
                <span>您暂未邀请任何人哦~</span>
            </div>
            <div v-show="!isData" class="hasData">
                <p class="recordTitle">开通乘车码记录</p>
                <!-- 列表 -->
                <div class="single" v-for="(item, index) in list" :key="index">
                    <div class="top">
                        <span
                            >手机号：{{
                                noPassByMobile(item.newUserPhone)
                            }}</span
                        >
                        <span
                            v-show="item.firstOpen == 0"
                            :style="{ color: '#ff4639' }"
                            >未开通</span
                        >
                        <span
                            v-show="item.firstOpen == 1"
                            :style="{ color: '#36CC40' }"
                            >已开通</span
                        >
                    </div>
                    <div class="bottom">
                        开通时间：{{ item.openTime ? item.openTime : "无" }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import { Base64 } from "js-base64";
import axios from "axios";
import { inviteList } from "@/api/statistics";
import { Toast } from "vant";
export default {
    components: { NavBar },
    data() {
        return {
            isData: false,
            list: [],
            sum: "", //未开通
            sum2: "", // 已开通
            info: {},
        };
    },
    computed: {},
    mounted() {
        var info = this.getQuery("info");
        if (info !== null) {
            console.log('info',info)
            info = decodeURIComponent(info);
            console.log('info2',info)
            info = Base64.decode(info);
            console.log('info3',info)
            
            info = JSON.parse(info);
            this.info = info;
        } else {
            Toast.fail("获取用户信息失败!");
        }
        Toast.loading({
            duration: 1, // 持续展示 toast
            forbidClick: true,
            message: "加载中...",
        });
        let url = process.env.VUE_APP_BASE_API+"/api/users/invite/list";
        let data = {
            head: {
                deviceId: this.info.deviceId,
            },
            body: {},
        };
        let options = {
            url,
            method: "POST",
            headers: { "MAASP-TOKEN": this.info["MAASP-TOKEN"] },
            data,
        };
        axios(options).then((res) => {
            if (res.data.code == 200) {
                if (res.data.data.length > 0) {
                    this.list = res.data.data;
                    this.getCount();
                } else {
                    this.isData = true;
                }
                Toast.clear();
            } else {
                Toast.fail(res.data.msg);
                this.isData = true;
            }
        });
        // 手动清除 Toast
        Toast.clear();
    },

    methods: {
        getQuery(param) {
            var currentUrl = window.location.href; //获取当前链接
            var arr = currentUrl.split("?"); //分割域名和参数界限
            if (arr.length > 1) {
                arr = arr[1].split("&"); //分割参数
                for (var i = 0; i < arr.length; i++) {
                    var tem = arr[i].split("="); //分割参数名和参数内容
                    if (tem[0] == param) {
                        return tem[1];
                    }
                }
                return null;
            } else {
                return null;
            }
        },
        noPassByMobile(str) {
            if (null != str && str != undefined) {
                var pat = /(\d{3})\d*(\d{4})/;
                return str.replace(pat, "$1****$2");
            } else {
                return "";
            }
        },
        // 计算总数
        getCount() {
            let sum = 0;
            let sum2 = 0;
            this.list.forEach((item) => {
                if (item.firstOpen == 0) {
                    sum += 1;
                } else {
                    sum2 += 1;
                }
            });
            //返回
            this.sum = sum;
            this.sum2 = sum2;
        },
    },
};
</script>

<style lang="scss" scoped>
.Statistics {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: rgb(241, 237, 237);
    ::v-deep .van-grid-item__content {
        padding: 0;
    }
    .count {
        padding: 20px 0;
        width: 375px;
        height: 40px;
        background: #fff;
        display: flex;
        > div {
            flex: 1;
        }
        > div:first-of-type {
            border-right: 1px solid #c9c6c6;
        }
        .label {
            p {
                margin: 0;
            }
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #363636;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
        }
    }

    .list {
        flex: 1;
        width: 100%;
        overflow-y: scroll;
        display: flex;
        align-items: center;
        justify-content: center;
        .null {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
                width: 50px;
                height: 45px;
                margin-bottom: 10px;
            }
            span {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #bbbbbb;
                line-height: 24px;
            }
        }

        .hasData {
            width: 100%;
            height: 100%;
            .recordTitle {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #9c9c9c;
                text-align: center;
            }
            .single {
                width: 343px;
                height: 60px;
                padding: 15px;
                background: #ffffff;
                border: 1px solid #e5e5e5;
                display: flex;
                flex-direction: column;
                margin-bottom: 10px;
                > div {
                    flex: 1;
                }
                > .top {
                    display: flex;
                    justify-content: space-between;
                    > span:first-of-type {
                        font-size: 15px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #363636;
                    }
                    > span:not(:first-of-type) {
                        font-size: 18px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                    }
                }
                > .bottom {
                    font-size: 15px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #9c9c9c;
                }
            }
        }
    }
}
</style>